import { render, staticRenderFns } from "./infoTable.vue?vue&type=template&id=4d4c82a1&scoped=true"
import script from "./infoTable.vue?vue&type=script&lang=js"
export * from "./infoTable.vue?vue&type=script&lang=js"
import style0 from "./infoTable.vue?vue&type=style&index=0&id=4d4c82a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c82a1",
  null
  
)

export default component.exports